import React from 'react';
import SectionLabel from './SectionLabel';
import useFadeIn from '../hooks/useFadeIn';
import { skillGroups } from '../data';
import '../styles/theme.css';

export default function Skills() {
  const fade = useFadeIn();

  return (
    <section id="skills" className="section">
      <SectionLabel>Skills</SectionLabel>
      <div ref={fade.ref} style={fade.style} className="skills-grid">
        {skillGroups.map(({ title, tags }) => (
          <div key={title} className="skill-card">
            <div className="skill-title">{title}</div>
            <div className="skill-tags">
              {tags.map(tag => (
                <span key={tag} className="skill-tag">{tag}</span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
